
<div class="modal-body read-device-selection owp">
  <div class="row signifyBold20px owpTitle">Enter OEM Write Protection Password</div>
  <div class="row mt-4">
    <div class="col-12">
      <form id="OWP-password-entry-form" [formGroup]="newPasswordForm">
        <div class="mt-2 pwd-row align-items-center">
          <div class="pwd-wrapper ml-1">
            <input id="OWP-password-input-1" #pwd1 [type]="showAllPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'" [ngClass]="{ 'showingError': (f.newPasswordInputBox1.dirty || submitted) && f.newPasswordInputBox1.errors }"
              formControlName="newPasswordInputBox1" class="pwd" minlength="1" maxlength="3"
              (keypress)="numberOnly($event)" (input)="onAutoAdvance('newPasswordInputBox1', pwd2)" (change)="onSubmit($event,'newPasswordInputBox1','newPassword')" />
            </div>
            <div class="pwd-wrapper ml-2">
              <input id="OWP-password-input-2" #pwd2 [type]="showAllPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'" [ngClass]="{ 'showingError': (f.newPasswordInputBox2.dirty || submitted) && f.newPasswordInputBox2.errors }"
                formControlName="newPasswordInputBox2" class="pwd" minlength="1" maxlength="3"
                (keypress)="numberOnly($event)" (keydown)="onBackspaceNavigate($event, pwd1, 'newPasswordInputBox2')" (input)="onAutoAdvance('newPasswordInputBox2', pwd3)" (change)="onSubmit($event,'newPasswordInputBox2','newPassword')" />
              </div>
              <div class="pwd-wrapper ml-2">
                <input id="OWP-password-input-3" #pwd3 [type]="showAllPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'" [ngClass]="{ 'showingError': (f.newPasswordInputBox3.dirty || submitted) && f.newPasswordInputBox3.errors }"
                  formControlName="newPasswordInputBox3" class="pwd" minlength="1" maxlength="3"
                  (keypress)="numberOnly($event)" (keydown)="onBackspaceNavigate($event, pwd2, 'newPasswordInputBox3')" (input)="onAutoAdvance('newPasswordInputBox3', pwd4)" (change)="onSubmit($event,'newPasswordInputBox3','newPassword')" />
                </div>
                <div class="pwd-wrapper ml-2">
                  <input id="OWP-password-input-4" #pwd4 [type]="showAllPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'" [ngClass]="{ 'showingError': (f.newPasswordInputBox4.dirty || submitted) && f.newPasswordInputBox4.errors }"
                    formControlName="newPasswordInputBox4" class="pwd" minlength="1" maxlength="3"
                    (keypress)="numberOnly($event)" (keydown)="onBackspaceNavigate($event, pwd3, 'newPasswordInputBox4')" (input)="onAutoAdvance('newPasswordInputBox4', null)" (change)="onSubmit($event,'newPasswordInputBox4','newPassword')" />
                  </div>
                  <button id="OWP-password-visibility-toggle" type="button" class="pwd-toggle-wrapper ml-2" (click)="toggleShowAllPasswords()" [title]="showAllPasswords ? 'Hide password' : 'Show password'">
                    @if (!showAllPasswords) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    }
                    @if (showAllPasswords) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                        <line x1="1" y1="1" x2="23" y2="23"></line>
                      </svg>
                    }
                  </button>
                </div>
                @if ((submitted || newPasswordForm.dirty) && newPasswordForm.invalid) {
                  <div id="OWP-password-inline-error" class="owp-inline-error">
                    @if (!newPasswordForm.errors?.allZero && !newPasswordForm.errors?.all255) {
                      Each value must be between 0 and 255.
                    }
                    @if (newPasswordForm.errors?.allZero) {
                      All four values cannot be 0.
                    }
                    @if (newPasswordForm.errors?.all255) {
                      All four values cannot be 255.
                    }
                  </div>
                }
              </form>
            </div>

          </div>

          <div class="row owp-btn-all">
            <div class="col-8">
              <button id="OWP-password-cancel-button" type="button" class="btn prev-refbtn"  (click)="onCancelClick()">Cancel</button>
            </div>

            <div class="col-4">
              <button id="OWP-password-ok-button" type="button" class="btn next-okbtn" [disabled]="newPasswordForm.invalid" (click)="sendPassword()">OK</button>
            </div>

          </div>
        </div>